export default __webpack_public_path__ + "static/media/ban-img.ebf8c8f6.png";